import { Injectable } from "@angular/core";
import { Order } from "../../../../objects/orders/order";
import { OrderService } from "../../../../services/orderService";
import { ActivatedRoute, ActivatedRouteSnapshot, Params } from "@angular/router";
import { BaseResponse } from "../../../../objects/common/baseResponse";
import { CalculatorHelper } from "../../../../common/helpers/calculatorHelper";
import { OrderStatus } from "../../../../objects/orders/orderStatus";
/**
 * Created by vadim.m on 9/14/2017.
 */

@Injectable()
export class OrderDetailsResolver {

    constructor(private orderService: OrderService) {
    }

    public resolve(route: ActivatedRouteSnapshot): Promise<BaseResponse<Order>> {
        let orderId = route.params["id"];

        if (String.isNullOrEmpty(orderId))
            orderId = route.params['orderId'];

        if (!orderId)
            return null;

        return this.orderService.getById(orderId);
    }
}



// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/orderDetails/orderDetails.resolver.ts